import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class LangInterceptorService implements HttpInterceptor {
  constructor(private translate: TranslateService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !request ||
      !request.url ||
      (request.url.startsWith("http") &&
        !(environment.apiURL && request.url.startsWith(environment.apiURL)))
    ) {
      return next.handle(request);
    }

    if (this.translate.currentLang) {
      request = request.clone({
        setParams: {
          language: this.translate.currentLang,
        },
      });
    }

    return next.handle(request);
  }
}
